import React, { useEffect, useState, useRef } from 'react';

import { Grid, MenuItem, Button } from '@material-ui/core';

import { Form, Input, Select as SelectAntd, Spin } from 'antd';
import { useSnackbar } from 'notistack';
import ButtonComponent from '@components/Shared/Buttons/Button';

import Service, { IApproveSolicitacao } from './services';

interface IProps {
  finishCreate?: Function;
  solicitacoes_programa_id: any;
}


const SolicitacaoComponent: React.FC<IProps> = ({
  finishCreate,
  solicitacoes_programa_id,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [formRef] = Form.useForm();

  const [loadingCreate, setLoadingCreate] = useState(false);


  const [loading, setLoading] = useState(true);

  const [NovoStatusSolicitacao, setNovoStatusSolicitacao] = useState(true);

  const [loadingApproveSolicitacao, setLoadingApproveSolicitacao] =
    useState(false);

  useEffect(() => {
    const init = async () => {
      const service = new Service();
    };

    init();
    setLoading(false);
  }, []);

  const aprovaSolicitacao = async () => {
    const componentRecuseSolicitacaoServices = new Service();
    setLoadingApproveSolicitacao(true);

    const recuseSolicitacaoResponse =
      await componentRecuseSolicitacaoServices.ApproveSolicitacao({
        solicitacoes_programa_id,
        NovoStatusSolicitacao
      });

    if (!recuseSolicitacaoResponse.error) {
      setLoadingCreate(false);
      setLoading(false);
      setLoadingApproveSolicitacao(false);
      enqueueSnackbar(`Solicitação aprovada com sucesso!`, {
        title: 'Solicitação aprovada com sucesso!',
        variant: 'success',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });

      window.location.reload();
    } else {

      enqueueSnackbar(`Ocorreu um erro`, {
        title: 'Ocorreu um erro ',
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });

      setLoadingApproveSolicitacao(false);
      setLoading(false);
    }


  };

  return (
    <Grid container>
      <Grid container item sm={12}>
        <Spin
          size="large"
          spinning={loadingApproveSolicitacao}
          tip={loadingApproveSolicitacao ? 'Enviando dados...' : ''}
        >
          <Grid
            container
            item
            xs={12}
            md={12}
            justify="center"
            alignItems="center"
          >
            <Form form={formRef} style={{ width: '100%' }} layout="vertical">
              <Grid item lg={12} xs={12}>
              Clique em confirmar para aprovar a(s) solicitação(ões) selecionada(s).
              </Grid>

              <Grid container justify="center" alignItems="center">
                <Grid item sm={6} xs={12} style={{ paddingTop: 10 }}>
                  <ButtonComponent
                    color="secondary"
                    fullWidth
                    onClick={aprovaSolicitacao}
                  >
                    Confirmar
                  </ButtonComponent>
                </Grid>
              </Grid>
            </Form>
          </Grid>
        </Spin>
      </Grid>
    </Grid>
  );
};

export default SolicitacaoComponent;
